import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import Header from '../components/Header';

export default function EntryPage() {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleJoin = async (e) => {
    e.preventDefault();
    const trimmed = code.trim().toUpperCase();
    if (trimmed.length !== 6) {
      setError('Код комнаты должен состоять из 6 символов');
      return;
    }
    setLoading(true); setError('');
    try {
      await api.getRoom(trimmed);
      navigate(`/room/${trimmed}`);
    } catch {
      setError('Комната не найдена или устарела. Проверьте код.');
    } finally { setLoading(false); }
  };

  return (
    <div className="app-shell">
      <Header />
      <main className="entry-screen">
        <div className="entry-hero">
          <img src="/muzon/logo.png" alt="Muzon" className="entry-hero-logo" />
          <h1>Muzon</h1>
          <p>Заказывайте музыку на банкете или свадьбе.<br />Введите код комнаты, который дал вам диджей.</p>
        </div>

        <div className="entry-card">
          <h2>Войти в комнату</h2>
          <form className="entry-form" onSubmit={handleJoin}>
            <div className="input-group">
              <label className="input-label">Код комнаты</label>
              <input
                className="input input-code"
                type="text"
                maxLength={6}
                placeholder="ABC123"
                value={code}
                onChange={e => setCode(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ''))}
                autoFocus
                autoComplete="off"
                spellCheck={false}
              />
            </div>
            {error && <div className="alert alert-error">{error}</div>}
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? <span className="spinner" /> : null}
              {loading ? 'Проверяем...' : 'Войти →'}
            </button>
          </form>

          <div className="divider" />

          <div className="entry-links">
            <button className="btn btn-secondary btn-sm" onClick={() => navigate('/login?role=dj')}>
              🎧 Я диджей
            </button>
            <button className="btn btn-secondary btn-sm" onClick={() => navigate('/login?role=admin')}>
              ⚙ Администратор
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
